import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Prodotto} from "../../Progetti/Models/Prodotto";
import {Permission} from "../../Login/_guards/Permission";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiPathsService} from "../../api-paths.service";
import { environment } from 'src/environments/environment';
import { ListaProdottiComponent } from '../lista-prodotti/lista-prodotti.component';

@Component({
  selector: 'app-ricambi-list',
  templateUrl: './Ricambi.component.html'
})
export class RicambiComponent implements OnInit {
  @Input() items : Prodotto[] = [];
  @Output() itemsChange = new EventEmitter<Prodotto[]>();
  @Input() prodotto : Prodotto ;
  @Output() prodottoChange = new EventEmitter<Prodotto>();
  @Input() HasAddButton : boolean = true;
  @Input() HasDeleteButton : boolean = true;
  @Input() Editable : boolean = true;
  @Input() Tipo: number;

  environment = environment;
  constructor(
    public permission: Permission,
    private modalService: NgbModal,
    public apiPaths: ApiPathsService,
  ) { }

  ngOnInit(): void {
  }

  Delete(prodotto: Prodotto) {
    if(!confirm('Sei sicuro di voler eliminare questo elemento dalla lista?')) return;
    var index = this.items.findIndex(x=> x == prodotto);
    if(index === -1)return;
    this.items.splice(index, 1);
  }

  Add() {
    let attmodal = this.modalService.open(ListaProdottiComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ListaProdottiComponent>attmodal.componentInstance).Tipo = this.Tipo;
    (<ListaProdottiComponent>attmodal.componentInstance).HasAddButton = false;
    (<ListaProdottiComponent>attmodal.componentInstance).HasDeleteButton = false;
    (<ListaProdottiComponent>attmodal.componentInstance).HasEditButton = false;
    (<ListaProdottiComponent>attmodal.componentInstance).HasRestoreButton = false;
    (<ListaProdottiComponent>attmodal.componentInstance).Modale = true;
    (<ListaProdottiComponent>attmodal.componentInstance).AddClicked.subscribe(data=> {

      if(!(this.prodotto?.ricambiObject?.length>0))
        this.prodotto.ricambiObject = [];
      this.prodotto.ricambiObject.push(data);

      attmodal.dismiss();
    });
  }

  ChangeHandler(item: { OnChange: string; Event: any }) {
    switch (item.OnChange ) {
      case 'OnDelete':
        var id = this.prodotto.ricambiObject.findIndex(x=> x == item.Event)
        if(id>-1 && confirm('Sei sicuro di voler eliminare questo elemento dalla lista?')) {
          this.prodotto.ricambiObject.splice(id, 1);
        }
        break;
    }
  }
}
